import React from 'react'

import ReactApexChart from 'react-apexcharts'

const Chart = ({ data }) => {
    const series = [{
        name: 'Income',
        data: [4, 7, 9, 12, 15, 8, 13, 5, 9, 0.2, 0.2, 0.2]
    }, {
        name: 'Withdrawal',
        data: [12, 8, 12, 10, 4, 9, 3, 1, 7, 0.2, 0.2, 0.2]
    }]

    const options = {

        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '75%',
                endingShape: 'rounded',
                borderRadius: 1,
                // borderRadiusApplication: 'end',

            },


        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 0,
            colors: ['transparent']
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yaxis: {
            show: false
        },
        fill: {
            opacity: 1
        },

        colors: ['#57F2A8', '#8E75FF']

    }


    return <ReactApexChart options={options} series={series} type="bar" height={350} width={'100%'} />

}

export default Chart